export default "__VITE_ASSET__BPWSUyrO__"